// 机场监控
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Card, Table, theme, Tag, message } from 'antd'
import { CheckCircleOutlined, ThunderboltOutlined, SyncOutlined, ClockCircleOutlined } from '@ant-design/icons'


import { basicPath } from '@/router/config.js'
import { getAllDockInfoApi } from '@/server/airportCamera.js'


function AirportSurveillance () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数

  const token = localStorage.getItem('dock_token');
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色

  const [loading, setLoading] = useState(false)//加载中···

  const [dataList, setDataList] = useState([])

  const getAllDockInfo = async () => {//获取当前用户的所有机场信息
    setLoading(true)
    let res = await getAllDockInfoApi({ access_token: token })
    setLoading(false)
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); }
    setDataList([...res.data])
  }

  const columns = [//表头
    {
      title: '设备码',
      dataIndex: 'dockSn',
    },
    {
      title: '机场名称',
      dataIndex: 'dockName',
      render: (text, record) => {
        return (
          <>
            {
              text
                ? <span className='opa85'>{text}</span>
                : <span className='opa25'>-</span>
            }
          </>
        )
      }
    },
    {
      title: '无人机电量(%)',
      dataIndex: 'capacity_percent',
      render: (text, record) => {
        return (
          <>
            {
              text
                ? <span className='opa85'>{text}</span>
                : <span className='opa25'>-</span>
            }
          </>
        )
      }
    },
    {
      title: '状态',
      dataIndex: 'RID',
      render: (text, record) => {
        if (record.offline) {
          return <Tag icon={<ClockCircleOutlined />} color="default">离线</Tag>
        } else if (record.RID !== 0 || record.InsID) {
          return <Tag icon={<SyncOutlined spin />} color="processing">执行中</Tag>
        } else if (record.drone_charge_state) {
          return <Tag icon={<ThunderboltOutlined />} color="success">充电</Tag>
        } else {
          return <Tag icon={<CheckCircleOutlined />} color="warning">待机</Tag>
        }
      }
    },
    {
      title: '航线',
      dataIndex: 'routes_name',
      render: (text, record) => {
        return (
          <>
            {
              text
                ? <span className='opa85'>{text}</span>
                : <span className='opa25'>-</span>
            }
          </>
        )
      }
    },
    {
      title: '操作',
      width: 60,
      dataIndex: '',
      render: (text, record) => {
        return (
          <span
            className='pointer'
            style={{ color: '#1668DC' }}
            onClick={() => { window.open(`${basicPath}/surveillance_info?${record.id}`) }}
          >
            进入
          </span>
        )
      }
    },
  ]

  useEffect(() => {
    getAllDockInfo()
    // eslint-disable-next-line
  }, [])

  return (
    <Card className='mar24' style={{ border: 0 }} styles={{ body: { padding: 24 } }}>
      <Table
        rowKey='id'
        dataSource={dataList}
        pagination={false}
        columns={columns}
        loading={loading}
      />
    </Card>
  )
}
export default AirportSurveillance;